if (!customElements.get('bundle-offer')) {
  customElements.define(
    'bundle-offer',
    class BundleOffer extends HTMLElement {
      constructor() {
        super();

        this.selectedQuantity = 1;
        this.selectedDiscount = 0;
        this.selectedVariantIds = [];
      }

      connectedCallback() {
        this.form = document.getElementById(this.dataset.productFormId);
        this.productForm = this.form?.closest('product-form');
        this.variantIdInput = this.form?.querySelector('[name="id"]');
        this.quantityInput = document.getElementById(`Quantity-${this.dataset.sectionId}`) || this.form?.querySelector('[name="quantity"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.productForm?.querySelector('[type="submit"]');
        this.errorMessageWrapper = this.productForm?.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.productForm?.querySelector('.product-form__error-message');
        this.slots = this.querySelector('[data-bundle-slots]');
        this.slotTemplate = this.querySelector('[data-bundle-slot-template]');
        this.variantImages = this.querySelector('[data-bundle-variant-images]');
        this.colorTitle = this.querySelector('[data-bundle-color-title]');

        this.hideNativeColorPicker();
        this.applyVariantImages();
        this.bindTierButtons();
        this.bindQuantityInput();
        this.renderSlots();

        this.form?.addEventListener('submit', this.onSubmit.bind(this), true);
      }

      bindQuantityInput() {
        this.quantityInput?.addEventListener('change', () => {
          if (this.syncingQuantity) return;

          const quantity = Number(this.quantityInput.value) || 1;
          const supportedQuantity = Math.min(Math.max(quantity, 1), 3);
          const tierButton = this.querySelector(`[data-bundle-tier][data-quantity="${supportedQuantity}"]`);
          tierButton?.click();
        });
      }

      bindTierButtons() {
        this.querySelectorAll('[data-bundle-tier]').forEach((button) => {
          button.addEventListener('click', () => {
            this.selectedQuantity = Number(button.dataset.quantity) || 1;
            this.selectedDiscount = Number(button.dataset.discount) || 0;

            this.querySelectorAll('[data-bundle-tier]').forEach((tierButton) => {
              const isSelected = tierButton === button;
              tierButton.classList.toggle('is-selected', isSelected);
              tierButton.setAttribute('aria-pressed', String(isSelected));
            });

            this.renderSlots();
          });
        });
      }

      hideNativeColorPicker() {
        const productContainer = this.closest('product-info, .product, [data-section]') || this.parentElement;
        if (!productContainer || !this.slotTemplate) return;

        productContainer.querySelectorAll('variant-selects .product-form__input').forEach((input) => {
          const label = input.querySelector('legend, label');
          const labelText = label?.textContent?.trim().toLowerCase() || '';
          if (labelText.includes('color') || labelText.includes('colour')) {
            input.hidden = true;
            input.classList.add('hidden');
            input.dataset.bundleHidden = 'true';
          }
        });
      }

      applyVariantImages() {
        if (!this.slotTemplate || !this.variantImages) return;

        let variants;
        try {
          variants = JSON.parse(this.variantImages.textContent);
        } catch (error) {
          console.error('Unable to read bundle variant images.', error);
          return;
        }

        const imagesByVariantId = new Map(
          variants.map((variant) => [
            String(variant.id),
            variant.featured_media?.preview_image?.src || variant.featured_image?.src || null,
          ])
        );

        this.slotTemplate.content.querySelectorAll('[data-bundle-color-option]').forEach((button) => {
          if (button.classList.contains('bb-bundle-color--image')) return;

          const imageUrl = imagesByVariantId.get(button.dataset.variantId);
          if (!imageUrl) return;

          const imageWrapper = document.createElement('span');
          imageWrapper.className = 'bb-bundle-color__image';
          imageWrapper.setAttribute('aria-hidden', 'true');

          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = button.dataset.colorName || '';
          image.loading = 'lazy';
          image.width = 180;
          image.height = 180;
          imageWrapper.appendChild(image);

          const accessibleLabel = document.createElement('span');
          accessibleLabel.className = 'visually-hidden';
          accessibleLabel.textContent = button.dataset.colorName || '';

          button.replaceChildren(imageWrapper, accessibleLabel);
          button.classList.add('bb-bundle-color--image');
        });
      }

      renderSlots() {
        if (!this.slots || !this.slotTemplate) {
          this.updateNativeQuantity();
          return;
        }

        const previousSelections = this.getSelections().map((selection) => selection.variantId);
        this.slots.innerHTML = '';

        for (let index = 0; index < this.selectedQuantity; index += 1) {
          const slot = this.slotTemplate.content.firstElementChild.cloneNode(true);
          slot.querySelector('[data-slot-number]').textContent = String(index + 1);
          this.slots.appendChild(slot);

          const preferredVariantId = previousSelections[index] || previousSelections[0] || this.dataset.defaultVariantId;
          const preferredButton = slot.querySelector(`[data-bundle-color-option][data-variant-id="${preferredVariantId}"]`);
          const defaultButton = preferredButton || slot.querySelector('[data-bundle-color-option][data-default-selected="true"]') || slot.querySelector('[data-bundle-color-option]:not([disabled])');

          if (defaultButton) this.selectColor(defaultButton);
        }

        this.slots.querySelectorAll('[data-bundle-color-option]').forEach((button) => {
          button.addEventListener('click', () => this.selectColor(button));
        });

        if (this.colorTitle) {
          this.colorTitle.textContent = `Choose ${this.selectedQuantity} ${this.selectedQuantity === 1 ? 'color' : 'colors'}`;
        }

        this.updateNativeQuantity();
        this.updateNativeVariant();
      }

      selectColor(button) {
        const slot = button.closest('.bb-bundle-slot');
        if (!slot) return;

        slot.querySelectorAll('[data-bundle-color-option]').forEach((colorButton) => {
          const isSelected = colorButton === button;
          colorButton.classList.toggle('is-selected', isSelected);
          colorButton.setAttribute('aria-pressed', String(isSelected));
        });

        this.updateNativeVariant();
      }

      getSelections() {
        return Array.from(this.querySelectorAll('.bb-bundle-slot [data-bundle-color-option].is-selected')).map((button) => ({
          variantId: Number(button.dataset.variantId),
          colorName: button.dataset.colorName,
        })).filter((selection) => selection.variantId);
      }

      updateNativeQuantity() {
        if (this.quantityInput) {
          this.syncingQuantity = true;
          this.quantityInput.value = String(this.selectedQuantity);
          this.quantityInput.setAttribute('value', String(this.selectedQuantity));
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.syncingQuantity = false;
        }
      }

      updateNativeVariant() {
        const firstSelection = this.getSelections()[0];
        if (firstSelection && this.variantIdInput) {
          this.variantIdInput.value = String(firstSelection.variantId);
          this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onSubmit(event) {
        if (!this.form || !this.submitButton || !this.slotTemplate) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const selections = this.getSelections();
        if (selections.length !== this.selectedQuantity) {
          this.showError(`Please choose ${this.selectedQuantity} ${this.selectedQuantity === 1 ? 'color' : 'colors'} for this offer.`);
          return;
        }

        this.addBundleToCart(selections);
      }

      addBundleToCart(selections) {
        this.showError(false);
        this.setLoading(true);

        const groupedSelections = selections.reduce((groups, selection) => {
          const key = `${selection.variantId}::${selection.colorName}`;
          groups[key] = groups[key] || { ...selection, quantity: 0 };
          groups[key].quantity += 1;
          return groups;
        }, {});

        const bundleId = `${Date.now()}-${Math.floor(Math.random() * 100000)}`;
        const offerLabel = this.selectedQuantity === 1 ? 'Single' : `Buy ${this.selectedQuantity}`;
        const items = Object.values(groupedSelections).map((selection) => ({
          id: selection.variantId,
          quantity: selection.quantity,
          properties: {
            'Bundle offer': offerLabel,
            'Selected color': selection.colorName,
            _bundle_id: bundleId,
            _bundle_discount: this.selectedDiscount ? `${this.selectedDiscount}%` : '0%',
          },
        }));

        const body = {
          items,
        };

        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig(),
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'bundle-offer',
                productVariantId: selections[0]?.variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showError(response.description || response.message);
              return;
            }

            if (this.productForm?.dataset.buyNow === 'true') {
              window.location.assign(this.productForm.dataset.checkoutUrl || '/checkout');
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'bundle-offer',
              productVariantId: selections[0]?.variantId,
              cartData: response,
            }).then(() => {
              this.cart.renderContents(response);
            });
          })
          .catch((error) => {
            console.error(error);
            this.showError('Something went wrong. Please try again.');
          })
          .finally(() => {
            this.setLoading(false);
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }

      setLoading(isLoading) {
        this.submitButton.toggleAttribute('aria-disabled', isLoading);
        this.submitButton.classList.toggle('loading', isLoading);
        this.productForm?.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      }

      showError(message) {
        if (!this.errorMessageWrapper || !this.errorMessage) return;
        this.errorMessageWrapper.toggleAttribute('hidden', !message);
        if (message) this.errorMessage.textContent = message;
      }
    }
  );
}
